import {
  docSourceEntityTypeToAssociationTables,
  docTargetEntityTypeToAssociationTables,
} from "building-types/associations/associationTables";
import type {
  DocAssociationSourceEntityType,
  DocAssociationTargetEntityType,
} from "building-types/associations/associationTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { DocEntityTypeToHandleType } from "../entity/docEntityTypeToHandleType";

export function isAssociationSourceEntityHandle(
  handle: DocEntityHandle,
): handle is DocEntityTypeToHandleType[DocAssociationSourceEntityType] {
  return handle.type in docSourceEntityTypeToAssociationTables;
}

export function isAssociationTargetEntityHandle(
  handle: DocEntityHandle,
): handle is DocEntityTypeToHandleType[DocAssociationTargetEntityType] {
  return handle.type in docTargetEntityTypeToAssociationTables;
}
